// start:ng42.barrel
import   './task.service';
import   './components';
// end:ng42.barrel

